const parseApplicationId = (id: string) =>
  /application~/i.test(id) ? id.split("~")[1] : id;

export { parseApplicationId };
